'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _NavApp = require('../pages/NavApp');

var _NavApp2 = _interopRequireDefault(_NavApp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var Dummy = function Dummy() {
  var title = capitalize(location.pathname.split('/').pop());
  return _react2.default.createElement(
    _NavApp2.default,
    { title: title },
    _react2.default.createElement(
      'div',
      { className: 'dummy-page' },
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'title' },
          title
        ),
        _react2.default.createElement(
          'div',
          { className: 'coming-soon' },
          'Coming Soon...'
        )
      )
    )
  );
};

Dummy.propTypes = {
  match: _react.PropTypes.object
};

exports.default = Dummy;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/pages/Dummy.js
// module id = 593
// module chunks = 171